import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { error } from 'console';
import { datastore } from 'googleapis/build/src/apis/datastore';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';

@Component({
  selector: "app-technology-questions",
  templateUrl: "./technology-questions.component.html",
  styleUrls: ["./technology-questions.component.css"],
})
export class TechnologyQuestionsComponent {
  displayedColumns = [
    "Category",
    "SubCategory",
    "Question",
    "Weightage",
    "actions",
  ];
  dataSource: MatTableDataSource<questionType>;
  dataSourceMap: Map<number, MatTableDataSource<questionType>> = new Map();
  // see wheather these are really required
  selectedCategoryId: number = 0;
  selectedSubCategoryId: number = 0;
  selectedWeightage: string = "";

  categories = [];
  subCategories = [];
  questions = [];
  technologies = [];
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private auditOverviewService: AuditOverviewService) {}

  ngOnInit(): void {
    this.getTechnologies();
    this.getCategories();
  }

  addNewRow(technologyId: any) {
    const newRow: any = {
      isEditMode: true,
      CategoryId: null,
      SubcategoryId: null,
      Question: "",
      Weightage: "",
    };
    const currentDataSource = this.dataSourceMap.get(technologyId);
    currentDataSource.data.push(newRow);
    currentDataSource._updateChangeSubscription();
  }

  deleteRow(questionMappingId: number, categoryId: number) {
    const dataSource = this.dataSourceMap.get(categoryId);
    const data = dataSource.data;
    const index = data.findIndex(
      (row) => row.QuestionMappingId === questionMappingId
    );
    // Ila data ni munde manupulate cheyyoddu frontend lo api result ni batti reload cheyyali
    if (index !== -1) {
      data.splice(index, 1);
      dataSource.data = data;
    }
    this.auditOverviewService.DeleteQuestion(questionMappingId).subscribe(
      (Response) => {
        console.log(Response);
      },
      (error) => {
        console.error("Error saving data", error);
      }
    );
  }

  editRow(row: any) {
    row.isEditMode = true;
    this.onCategoryChange(row.CategoryId);
    this.onSubCategoryChange(row.CategoryId, row.SubcategoryId);
  }

  Save(row: any, technologyId: number) {
    row.isEditMode = false;
    const tempObj: questionType = {
      questionId: row.Questionid,
      QuestionMappingId: row.QuestionMappingId,
      categoryId: row.CategoryId,
      subCategoryId: row.SubcategoryId,
      priorityOrder: 0,
      weightage: row.Weightage,
      technologyId: technologyId,
      isActive: true,
    };
    this.auditOverviewService.AddorUpdateTechnologyMapping(tempObj).subscribe(
      (response) => {
        console.log("Data saved successfully", response);
        this.getQuestions(technologyId);
        this.dataSource._updateChangeSubscription();
      },
      (error) => {
        console.error("Error saving data", error);
      }
    );
  }

  Cancel(row: any) {
    row.isEditMode = false;
  }

  getTechnologies() {
    this.auditOverviewService.GetTechnologiesDropdown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.technologies = response;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCategories() {
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.categories = response;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getQuestions(technologyId: any) {
    console.log(technologyId);
    this.auditOverviewService
      .getQuestionsByTehnology(technologyId)
      .subscribe((response) => {
        if (response.length > 0) {
          const dataArray = response.map((question) => {
            return {
              QuestionMappingId: question.questionMappingId,
              QuestionId: question.questionId,
              SubcategoryId: question.subCategoryId,
              SubCategoryName: question.subCategory,
              Question: question.questions,
              Weightage: question.weightage,
              CategoryId: question.categoryId,
              Category: question.categoryname,
            };
          });
          const dataSource = new MatTableDataSource<questionType>(dataArray);
          console.log(dataSource);
          this.dataSourceMap.set(technologyId, dataSource);
        }
      });
  }

  onCategoryChange(categoryId: number) {
    this.selectedCategoryId = categoryId;
    this.subCategories = []; // Clear existing subcategories

    if (categoryId !== 0) {
      this.auditOverviewService.getSubCategoryDropDown(categoryId).subscribe(
        (response) => {
          if (response?.length > 0) {
            this.subCategories = response;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  onSubCategoryChange(categoryId: number, subcategoryId: number) {
    this.selectedCategoryId = categoryId;
    this.selectedSubCategoryId = subcategoryId;
    this.questions = [];
    
    if (categoryId !== 0 && subcategoryId !== 0) {
      this.auditOverviewService
        .getQuestionsDropdown(
          this.selectedCategoryId,
          this.selectedSubCategoryId
        )
        .subscribe(
          (response) => {
            if (response?.length > 0) {
              this.questions = response;
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
}

export interface questionType {
  QuestionMappingId: number,
  questionId: number,
  categoryId: number,
  subCategoryId: number,
  weightage: string,
  technologyId: number,
  priorityOrder: number,
  isActive: boolean
}